import { render, staticRenderFns } from "./OpinionLists.vue?vue&type=template&id=dccb4aee&"
import script from "./OpinionLists.vue?vue&type=script&lang=js&"
export * from "./OpinionLists.vue?vue&type=script&lang=js&"
import style0 from "./OpinionLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports